import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import React, { useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { history } from "./helpers";

const ProductList = React.lazy(() =>
  import("./containers/ProductListing/productListing.jsx")
);
const ProductListGemba = React.lazy(() =>
  import("./containers/ProductListingGemba/productListingGemba.jsx")
);
const ProductLocator = React.lazy(() =>
  import("./containers/productLocator/productLocator.jsx")
);
const GlobalLoader = React.lazy(() =>
  import("../src/components/loader/loader")
);

function App() {
  var getTagAttr = document.getElementsByTagName("bsi-product-locator")[0];
  var showBrandList = getTagAttr.getAttribute("brandsListing");

  useEffect(() => {
    import(`./styles/index.js`)
  }, []);
  return (
    <div className="main-container-loc pl">
      <GlobalLoader />
      <div className="pl__container container">
        <div className="col-md-12">
          <Router history={history}>
            <Switch>
              {["", ""].map((path, index) => (
                showBrandList ? (
                  <Route path={path} exact component={ProductListGemba} key={index} />
                ) : (
                  <Route path={path} exact component={ProductList} key={index} />
                )
              ))}
              <Route path="/product-locator" component={ProductLocator} />
            </Switch>
          </Router>
        </div>
      </div>
    </div>
  );
}

export { App };
